import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../app-token.service";
import { HttpHandlerService } from "../http-handler.service";
import { Observable } from "rxjs";

@Injectable()

export class DRSService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getResourceEndPoint = 'drs';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }
    public GetById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/list?sc=${params?.id}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `&refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    public GetAllAwb(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/availableawb?`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
   
    public Add(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
    
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public Update(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }
    
    public DeleteAwbById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/awb/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    public Delete(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
    
    public UpdateStatus(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/awb/status`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GeneratePDF(drsId: string): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/print/${drsId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public updateFileIdInDrs(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/copy`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }
}